import { useEffect } from "react";
import { Link } from "react-router-dom";
import us_pc from "../../assets/images/us_pc.webp";
import us_mo from "../../assets/images/us_mo.webp";
import ar_white from "../../assets/images/ar_white.svg";
import home_white from "../../assets/images/home_white.svg";
import Contact from "../Contact/Contact";
import { legalPages } from "./legal-content";

export default function LegalPage({ type }) {
  const page = legalPages[type];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [type]);

  if (!page) return null;

  return (
    <div className="w-full">
      <div className="w-full">
        <div className="block md:hidden lg:hidden w-full relative h-[12rem] mt-16">
          <img src={us_mo} alt="" className="w-full h-[12rem] object-cover" />
          <div className="w-full absolute top-0 h-[12rem] bg-blue-sky-gradient6">
            <div className="absolute bottom-[20%] left-0 right-0 px-4 flex flex-col gap-2 items-center justify-center">
              <div className="flex items-center gap-2">
                <Link to="/">
                  <img src={home_white} alt="Trang chủ" />
                </Link>
                <img src={ar_white} alt="" />
                <p className="text-[1rem] font-normal text-white">{page.title}</p>
              </div>
              <p className="text-[1.5rem] font-semibold text-white text-center">
                {page.title}
              </p>
            </div>
          </div>
        </div>
        <div className="hidden md:block lg:block w-full relative h-[20rem] mt-28">
          <img src={us_pc} alt="" className="w-full h-[20rem] object-cover" />
          <div className="w-full absolute top-0 h-[20rem] bg-blue-sky-gradient6">
            <div className="absolute bottom-[35%] left-0 right-0 flex flex-col gap-2 items-center justify-center">
              <div className="flex items-center gap-2">
                <Link to="/">
                  <img src={home_white} alt="Trang chủ" />
                </Link>
                <img src={ar_white} alt="" />
                <p className="text-[1rem] font-normal text-white">{page.title}</p>
              </div>
              <p className="text-[2.25rem] font-semibold text-white">{page.title}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-10 lg:py-16 max-w-4xl">
        {/* Navigation Switcher to other legal docs */}
        <div className="mb-8 flex flex-wrap items-center justify-between gap-3 p-3 bg-white rounded-xl shadow-sm border border-gray-100">
          <div className="text-sm text-gray-500 font-medium">
            Tài liệu pháp lý & chính sách:
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <Link
              to="/chinh-sach-bao-mat"
              className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                type === "privacy"
                  ? "bg-[#1375B7] text-white"
                  : "text-gray-600 hover:text-[#1375B7] hover:bg-sky-50"
              }`}
            >
              Chính sách bảo mật
            </Link>
            <Link
              to="/dieu-khoan-su-dung"
              className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                type === "terms"
                  ? "bg-[#1375B7] text-white"
                  : "text-gray-600 hover:text-[#1375B7] hover:bg-sky-50"
              }`}
            >
              Điều khoản sử dụng
            </Link>
            <Link
              to="/dieu-khoan-tai-app"
              className="px-3 py-1.5 rounded-lg text-sm font-medium text-gray-600 hover:text-[#1375B7] hover:bg-sky-50 transition-colors"
            >
              Điều khoản tải app
            </Link>
          </div>
        </div>

        <p className="text-[#333] leading-7 mb-8">{page.intro}</p>
        {page.sections.map((section) => (
          <section key={section.heading} className="mb-8">
            <h2 className="text-[1.25rem] font-semibold text-[#1375B7] mb-3">
              {section.heading}
            </h2>
            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph} className="text-[#333] leading-7 mb-3">
                {paragraph}
              </p>
            ))}
            {section.privacyLinkParagraph && (
              <p className="text-[#333] leading-7 mb-3">
                BlueSkyIT cam kết bảo vệ thông tin cá nhân của người dùng theo
                quy định của pháp luật Việt Nam. Vui lòng tham khảo{" "}
                <Link
                  to="/chinh-sach-bao-mat"
                  className="text-[#1375B7] underline underline-offset-2"
                >
                  Chính sách bảo mật
                </Link>{" "}
                để biết thêm chi tiết.
              </p>
            )}
            {section.bullets?.length > 0 && (
              <ul className="list-disc pl-6 mb-3 space-y-2 text-[#333] leading-7">
                {section.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
            {section.afterBullets?.map((paragraph) => (
              <p key={paragraph} className="text-[#333] leading-7 mb-3">
                {paragraph}
              </p>
            ))}
          </section>
        ))}
        {page.footerLines?.map((line) => (
          <p key={line} className="text-[#333] leading-7 mb-2">
            {line}
          </p>
        ))}
      </div>

      <Contact />
    </div>
  );
}
